import Tippy from '@tippyjs/react';
import './ImageTooltip.scss';

export function ImageTooltip({
  tooltip,
  src,
  className,
}: {
  readonly tooltip: string;
  readonly src: string;
  readonly className?: string;
}): JSX.Element {
  return (
    <Tippy
      content={tooltip}
      placement="top"
      arrow
      delay={100}
      animation="shift-toward"
      appendTo={document.body}
    >
      <img src={src} className={`provider__logo ${className}`} alt={tooltip} />
    </Tippy>
  );
}

export default ImageTooltip;
